import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import Orientation from '../../components/utils/orientation';
import LevelBar from '../../components/padel/level';
import LevelBarY from '../../components/padel/levelY';

let Level = ({ cb, level }) => {
  return (
    <Orientation
      portrait={<LevelBarY power={level} cb={res => cb(res)} />}
      landscape={<LevelBar power={level} cb={res => cb(res)} />}
    />
  );
};

export default Level;
